import { render, staticRenderFns } from "./ThirteenthMonth.vue?vue&type=template&id=ece54be6&scoped=true"
import script from "./ThirteenthMonth.vue?vue&type=script&lang=js"
export * from "./ThirteenthMonth.vue?vue&type=script&lang=js"
import style0 from "./ThirteenthMonth.vue?vue&type=style&index=0&id=ece54be6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece54be6",
  null
  
)

export default component.exports